import { cn } from "@/lib/utils";

export type StatusBadgeKind = "live" | "mock" | "future";

// `mock` = page is wired up but the data shown is illustrative.
// `future` = page is roadmap-only. The two render different copy so a
// mock panel doesn't read as fake data, and a Guide entry doesn't
// imply finished work.
const COPY: Record<StatusBadgeKind, string> = {
  live: "Live",
  mock: "Mock data",
  future: "Coming soon",
};

const COMING_SOON_TONE =
  "border-warm-gray-04 text-warm-gray-07 border border-dashed bg-transparent";

const TONE: Record<StatusBadgeKind, string> = {
  live: "bg-primary text-primary-foreground",
  mock: COMING_SOON_TONE,
  future: COMING_SOON_TONE,
};

export function StatusBadge({
  kind,
  label,
  className,
}: {
  kind: StatusBadgeKind;
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-[10px] font-medium tracking-[0.16em] uppercase",
        TONE[kind],
        className,
      )}
    >
      {/* The pulsing dot signals "this feature is currently live" — pair it
          with the default "Live" copy. When the caller passes a custom
          `label` (e.g. "Real data" in the demo legend), they've opted out
          of that semantic, so the dot would be misleading. */}
      {kind === "live" && !label && (
        <span
          aria-hidden
          className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white"
        />
      )}
      {label ?? COPY[kind]}
    </span>
  );
}
